import { ParallaxScene, ParallaxLayer } from "../ParallaxScene";
import { SocialPortraitCard } from "../SocialPortraitCard";
import { feedItems } from "../../data/demoContent";
import { useDemo } from "../../context/DemoContext";
import { useIsDesktop, useMediaQuery } from "../../hooks/useMedia";
import { Words } from "../Words";

const SPEEDS = [
  [60, -90],
  [180, -200],
  [90, -130],
  [200, -170],
];
const STAGGER = [0, 90, 36, 130];

const FeedCard = ({ item, index }) => {
  const { setPreview } = useDemo();
  return <SocialPortraitCard item={item} radius={30} testId={`feed-card-${index + 1}`} onOpen={() => setPreview(item)} />;
};

const Columns = ({ cols }) => {
  const columns = Array.from({ length: cols }, (_, c) => feedItems.map((it, i) => [it, i]).filter(([, i]) => i % cols === c));
  return (
    <div className="mt-20 grid gap-6" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {columns.map((col, c) => (
        <ParallaxLayer key={c} y={SPEEDS[c]} style={{ marginTop: STAGGER[c] }} className="flex flex-col gap-6" data-testid={`feed-column-${c + 1}`}>
          {col.map(([it, i]) => (
            <FeedCard key={it.id} item={it} index={i} />
          ))}
        </ParallaxLayer>
      ))}
    </div>
  );
};

const MobileGrid = () => (
  <div className="mt-12 grid grid-cols-2 gap-3 sm:gap-5 md:grid-cols-3">
    {feedItems.map((it, i) => (
      <div key={it.id} className={i % 2 === 1 ? "translate-y-8 md:translate-y-0" : ""}>
        <FeedCard item={it} index={i} />
      </div>
    ))}
  </div>
);

export default function FeedSection() {
  const desktop = useIsDesktop();
  const xl = useMediaQuery("(min-width: 1280px)");
  return (
    <ParallaxScene
      as="section"
      id="feed"
      offset={["start end", "end start"]}
      data-testid="feed-section"
      className="feed-stage relative overflow-hidden pb-28 pt-28 text-white lg:pb-56 lg:pt-40"
    >
      <div className="relative mx-auto max-w-[1320px] px-5 lg:px-10">
        <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr] lg:items-end">
          <div>
            <p className="eyebrow eyebrow--dark">03 · A feed made of people</p>
            <h2 className="h-section mt-4" data-testid="feed-headline">
              <Words text="Less Scrolling." />
              <br />
              <Words text="More Living." start={2} className="text-gradient-cool" />
            </h2>
          </div>
          <p className="max-w-[460px] text-[18px] leading-relaxed text-white/65 sm:text-[20px] lg:justify-self-end">
            Your social world isn't an endless feed. It's the people, moments and experiences that matter to you.
          </p>
        </div>
        {desktop ? <Columns cols={xl ? 4 : 3} /> : <MobileGrid />}
      </div>
    </ParallaxScene>
  );
}
